import { render } from "./FishScene.vue?vue&type=template&id=f88d237c&scoped=true"
import script from "./FishScene.vue?vue&type=script&lang=js"
export * from "./FishScene.vue?vue&type=script&lang=js"

import "./FishScene.vue?vue&type=style&index=0&id=f88d237c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f88d237c"]])

export default __exports__